import { render } from "./IncomesOtherModal.vue?vue&type=template&id=bdac3a06"
import script from "./IncomesOtherModal.vue?vue&type=script&lang=js"
export * from "./IncomesOtherModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__